import { combineReducers } from "redux";

import { additionalChargesDetails } from "./reducer.additionalCharges"
const additionalChargeReducers = combineReducers({

  additionalChargesDetails

})
export default additionalChargeReducers;
